import {
  ButtonHTMLAttributes,
  forwardRef,
  ForwardRefExoticComponent,
  MouseEvent,
  ReactNode,
  Ref,
  RefAttributes,
} from 'react';

interface IButtonStatic {
  Button: any;
  Loader: any;
  LoaderWrapper: any;
}

export interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  className?: string;
  inverted?: boolean;
  loading?: boolean;
  primary?: boolean;
  secondary?: boolean;
  selected?: boolean;
  title?: string;
  label?: string;
}

type ButtonComponent = ForwardRefExoticComponent<IButtonProps & RefAttributes<HTMLButtonElement>> &
  IButtonStatic;

const Button = forwardRef(
  (
    { children, loading, onClick, title, type, value, label, ...rest }: IButtonProps,
    ref?: Ref<HTMLButtonElement>,
  ) => {
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
      if (onClick) {
        onClick(event);
      }
    };

    return (
      <button
        className="button"
        onClick={!loading ? handleClick : () => {}}
        ref={ref}
        // eslint-disable-next-line react/button-has-type
        type={type || 'button'}
        value={value || title}
        aria-label={label || title || ''}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      >
        {loading ? (
          <Button.LoaderWrapper>
            <Button.Loader />
          </Button.LoaderWrapper>
        ) : (
          <span>{title}</span>
        )}
        {!loading && children}
      </button>
    );
  },
) as ButtonComponent;

export default Button;
